import { useAutoNavigate } from '@betterment/js-runtime';
import { ErrorBoundary, WorkflowLayout } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { urlBuilder } from '../Shared/urlBuilder';

export const CustomPortfolioBuilderPage = () => {
  const accountId = useRequiredParam('accountId');

  const navigate = useAutoNavigate();

  const handleBack = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));
  const handleClose = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));

  return (
    <ErrorBoundary fallbackType="full" feature="performance_page" owner="investing_experience">
      <WorkflowLayout pageTitle="Custom Portfolio">
        <WorkflowLayout.Header onBack={handleBack} onClose={handleClose} workflowTitle="Custom Portfolio" />
        <WorkflowLayout.Content size="full" />
      </WorkflowLayout>
    </ErrorBoundary>
  );
};
